import Axios from '../axios';
import appConfig from '../../../app.config';
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { TFunction } from 'i18next'
import { logError } from '../../../shared';
import { IAnnualReport } from '../../interfaces/i-api-creaditCard'

async function getAnnualReportService(accountAgreementId: string, t: TFunction) {
    const response = await Axios
        .get<IAnnualReport>(
            `${appConfig.customerDataBaseUrl}/api/creditcard/annualreport?accountAgreementId=${accountAgreementId}`,
            await getHeadersWithJwtToken()
        )
        .then((result) => {
            return result.data as IAnnualReport
        })
        .catch((err) => {
            logError(err)
            if (err.response?.status === 404) {
                throw new Error(t('AnnualReportNoData'))
            } else {
                throw err
            }
        })
    return response as IAnnualReport
}
export default getAnnualReportService;